import firebase from 'firebase';

const firebaseConfig = {
  apiKey: 'APCnYtZDdtaeJEeEpZoKhrezqZQI7hD65JYcYjLy',
  authDomain: 'cliffhouse-pws.firebaseapp.com',
  databaseURL: 'https://cliffhouse-pws.firebaseio.com',
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.database();

export default db;



// WEBPACK FOOTER //
// ./src/db.js